/**
 * Register. GSAP
 */
gsap.registerPlugin(ScrollTrigger);
gsap.config({ trialWarn: false });
ScrollTrigger.config({ 
  ignoreMobileResize: true,
  limitCallbacks: true // Only runs callbacks when necessary to save CPU
});

// window.addEventListener("resize", () => {
//   ScrollTrigger.refresh();
// });

/********************************************************
 * HEADER WRAPPER STYLE (WHEN SLIDESHOW IS FIRST SECTION)
 ********************************************************/
// (function() {
//   const initInsetHeader = () => {
//     const triggerSection = document.querySelector('[data-header-inset-trigger]');
//     const headerWrapper = document.querySelector('.header__wrapper');

//     if (!triggerSection || !headerWrapper) return;

//     const observerOptions = {
//       root: null,
//       threshold: 0,
//       rootMargin: `-${headerWrapper.offsetHeight || 80}px 0px 0px 0px` 
//     };

//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           headerWrapper.style.setProperty('margin-inline', '0.625rem', 'important');
//         } else {
//           headerWrapper.style.setProperty('margin-inline', '0', 'important');
//         }
//       });
//     }, observerOptions);

//     observer.observe(triggerSection);
//   };

//   if (document.readyState === 'complete') {
//     initInsetHeader();
//   } else {
//     window.addEventListener('load', initInsetHeader);
//   }

//   document.addEventListener('shopify:section:load', (e) => {
//     if (e.target.querySelector('[data-header-inset-trigger]')) {
//       initInsetHeader();
//     }
//   });
// })();

/********************************
 * bl_bullet-point-banner.liquid
 ********************************/
if (!customElements.get('bl-bullet-point')) {
  class BlBulletPoint extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector('.bl-bp__wrapper');
      this.dots = this.querySelectorAll('.bl-bp__dot');
      this.currentIndex = 0;
      this.timer = null;
      this.scrollTimeout = null;
      this.itemsPerPage = 1;
      this.totalPages = 0;
      this.intervalDuration = 8000;
    }

    connectedCallback() {
      this.updateLayout();
      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const index = parseInt(dot.getAttribute('data-index'));
          this.goToPage(index, true); 
        });
      });

      this.wrapper.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          const newPageIndex = Math.round(this.wrapper.scrollLeft / this.wrapper.offsetWidth);
          if (newPageIndex !== this.currentIndex && newPageIndex < this.totalPages) {
            this.goToPage(newPageIndex, true); 
          }
        }, 50);
      }, { passive: true });

      window.addEventListener('resize', () => this.updateLayout());
      
      requestAnimationFrame(() => this.goToPage(0, false));
    }

    updateLayout() {
      const prevItemsPerPage = this.itemsPerPage;
      this.itemsPerPage = 1;
      this.totalPages = Math.ceil(this.dots.length / this.itemsPerPage);

      this.dots.forEach((dot, index) => {
        dot.style.display = index < this.totalPages ? 'block' : 'none';
      });

      if (prevItemsPerPage !== this.itemsPerPage) {
        this.goToPage(0, true);
      }
    }

    goToPage(index, isManual = false) {
      this.stopTimer();

      if (index >= this.totalPages) index = 0;
      this.currentIndex = index;

      const targetScroll = this.wrapper.offsetWidth * index;
      if (Math.abs(this.wrapper.scrollLeft - targetScroll) > 5) {
        this.wrapper.scrollTo({ left: targetScroll, behavior: 'smooth' });
      }

      this.dots.forEach(dot => dot.classList.remove('is-active'));
      if (this.dots[this.currentIndex]) {
        void this.dots[this.currentIndex].offsetWidth; 
        this.dots[this.currentIndex].classList.add('is-active');
      }

      this.startTimer();
    }

    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => {
        const nextIndex = (this.currentIndex + 1) % this.totalPages;
        this.goToPage(nextIndex, false);
      }, this.intervalDuration);
    }

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    disconnectedCallback() {
      this.stopTimer();
    }
  }

  customElements.define('bl-bullet-point', BlBulletPoint);
}

/********************************
 * bl_image-packery.liquid
 ********************************/
if (!customElements.get('bl-background-looping')) {
  class BlBackgroundLooping extends HTMLElement {
    connectedCallback() {
      this.textPath = this.querySelector('.loopTextPath');
      this.path = this.querySelector('path');
      if (!this.textPath || !this.path) return;

      this.offset = 0;
      this.phraseWidthPercent = 0;
      this.animationFrame = null;
      this.resizeObserver = new ResizeObserver(() => this.updateDimensions());
      this.resizeObserver.observe(this);

      this.animate();
    }

    updateDimensions() {
      const totalTextLength = this.textPath.getComputedTextLength();
      const pathLength = this.path.getTotalLength();

      if (totalTextLength > 0) {
        this.phraseWidthPercent = ((totalTextLength / 15) / pathLength) * 100;
      }
    }

    animate() {
      this.offset -= 0.05; 

      if (this.phraseWidthPercent > 0 && Math.abs(this.offset) >= this.phraseWidthPercent) {
        this.offset = 0;
      }

      this.textPath.setAttribute('startOffset', this.offset + '%');
      this.animationFrame = requestAnimationFrame(() => this.animate());
    }

    disconnectedCallback() {
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }
  customElements.define('bl-background-looping', BlBackgroundLooping);
}

if (!customElements.get('bl-ip-wrapper')) {
  class BlIpWrapper extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth < 700) {
        const items = this.querySelectorAll('.bl-ip__image');
        if (items.length >= 2) {
          requestAnimationFrame(() => {
            const secondItem = items[1];
            const scrollLeft = secondItem.offsetLeft + (secondItem.offsetWidth / 2) - (this.offsetWidth / 2);
            this.scrollTo({ left: scrollLeft, behavior: 'auto' });
          });
        }
      }
    }
  }
  customElements.define('bl-ip-wrapper', BlIpWrapper);
}

/********************************
 * bl_team-card.liquid
 ********************************/
if (!customElements.get('bl-team-card')) {
  customElements.define('bl-team-card', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.openPopup.bind(this));
    }

    connectedCallback() {
      this._reveal_fn();
    }

    _reveal_fn() {
      const tl = gsap.timeline({
        paused: true
      });

      tl.from(this.querySelector(".bl-tc__name_position p"), {
        opacity: 0,
        y: 20,
        duration: 0.4,
        ease: "power2.inOut"
      }, "<")
      
      ScrollTrigger.create({
        trigger: this.closest(".shopify-section"),
        start: "top 60%",
        onEnter: (self) => {
          if (self.progress < 1 && self.direction === 1) {
            tl.play();
            self.kill();
          }
        },
        onEnterBack: (self) => {
          tl.play();
          self.kill(); 
        }
      });
    }
    openPopup() {
      if (window.innerWidth > 999) return;

      const popupId = this.getAttribute('data-card-popup');
      const popup = document.getElementById(popupId);
      
      if (popup) {
        popup.setAttribute('open', '');
        document.body.style.overflow = 'hidden'; 
        if (!popup.dataset.closeBound) {
          const closePopup = () => {
            popup.removeAttribute('open');
            document.body.style.overflow = '';
          };
          
          const overlay = popup.querySelector('.bl-tc__card-popup_overlay');
          if (overlay) overlay.addEventListener('click', closePopup);

          const closeBtn = popup.querySelector('.bl-tc__close-btn');
          if (closeBtn) closeBtn.addEventListener('click', closePopup);

          popup.dataset.closeBound = "true";
        }
      }
    }
  });
}

if (!customElements.get('team-card-popup')) {
  customElements.define('team-card-popup', class extends HTMLElement {
    connectedCallback() {
      this.injectCloseButton();
      
      this.addEventListener('click', (event) => {
        const isOverlay = event.target.classList.contains('bl-tc__card-popup_overlay');
        const isCloseBtn = event.target.closest('.bl-tc__close-btn');
        
        if (isOverlay || isCloseBtn) {
          this.close();
        }
      });
    }

    injectCloseButton() {
      const contentContainer = this.querySelector('div:not(.bl-tc__card-popup_overlay)');
      if (contentContainer && !contentContainer.querySelector('.bl-tc__close-btn')) {
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'bl-tc__close-btn';
        closeBtn.innerHTML = '&times;'; 
        closeBtn.setAttribute('aria-label', 'Close');
        contentContainer.prepend(closeBtn);
      }
    }

    close() {
      this.removeAttribute('open');
      document.body.style.overflow = '';
    }
  });
}

/**************************************
 * bl_central-floating-elements.liquid
 **************************************/
if (!customElements.get('floating-element')) {
  class FloatingElement extends HTMLElement {
    constructor() {
      super();
      this.isAnimated = false;
      this._finalRect = { x: 0, y: 0, w: 0, h: 0 };
      this._handleResize = () => this.calculatePosition();
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this._handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._handleResize);
    }

    init() {
      if (window.innerWidth < 700) return;
      this.style.opacity = '0';
      this.style.visibility = 'hidden';
      this.style.position = 'absolute';
      this.style.whiteSpace = 'nowrap';
      this.style.zIndex = '2';

      const ro = new ResizeObserver(() => {
        if (this.parentElement.offsetHeight > 50) {
          this.initIntersection();
          ro.disconnect();
        }
      });
      ro.observe(this.parentElement);
    }

    initIntersection() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isAnimated) {
            this.isAnimated = true;
            this.calculatePosition(true); 
          }
        });
      }, { threshold: 0.1 });
      observer.observe(this.parentElement);
    }

    resetStyles() {
      const props = ['position','left','top','transform','opacity','visibility','transition','white-space','z-index'];
      props.forEach(p => this.style.removeProperty(p));
      this.classList.remove('is-floating');
      this.isAnimated = false; 
    }

    calculatePosition(triggerAnimation = false) {
      if (window.innerWidth < 700) {
        this.resetStyles();
        return;
      }

      const parent = this.parentElement;
      const allItems = Array.from(parent.querySelectorAll('floating-element'));
      const index = allItems.indexOf(this);
      const total = allItems.length;

      const pW = parent.offsetWidth;
      const pH = parent.offsetHeight;
      const centerX = pW / 2;
      const centerY = pH / 2;

      const myW = this.offsetWidth;
      const myH = this.offsetHeight;

      const half = Math.ceil(total / 2);
      const isTop = index < half;

      let angle;
      const sweep = Math.PI * 0.75; 
      if (isTop) {
        const step = sweep / (half > 1 ? half - 1 : 1);
        angle = -Math.PI + ((Math.PI - sweep) / 2) + (step * index);
      } else {
        const bottomIndex = index - half;
        const bottomTotal = total - half;
        const step = sweep / (bottomTotal > 1 ? bottomTotal - 1 : 1);
        angle = ((Math.PI - sweep) / 2) + (step * bottomIndex);
      }

      const rx = pW * 0.36;
      const ry = pH * 0.38;

      let tx = centerX + Math.cos(angle) * rx - (myW / 2);
      let ty = centerY + Math.sin(angle) * ry - (myH / 2);

      tx = Math.max(20, Math.min(tx, pW - myW - 20));
      ty = Math.max(20, Math.min(ty, pH - myH - 20));

      this._finalRect = { x: tx, y: ty, w: myW, h: myH };

      for (let i = 0; i < index; i++) {
        const other = allItems[i]._finalRect;
        if (!other || other.w === 0) continue;
        const padding = 20;
        if (this._finalRect.x < other.x + other.w + padding && this._finalRect.x + this._finalRect.w + padding > other.x && this._finalRect.y < other.y + other.h + padding && this._finalRect.y + this._finalRect.h + padding > other.y) {
          this._finalRect.y += isTop ? -45 : 45;
          this._finalRect.y = Math.max(20, Math.min(this._finalRect.y, pH - myH - 20));
        }
      }

      this.style.position = 'absolute';
      this.style.left = `${this._finalRect.x}px`;
      this.style.top = `${this._finalRect.y}px`;

      if (triggerAnimation) this.animateIn(index);
    }

    animateIn(index) {
      this.style.visibility = 'visible';
      this.style.opacity = '0';
      this.style.transform = 'translate3d(0, 20px, 0)';
      
      const duration = 1100;
      const delay = index * 120;

      setTimeout(() => {
        this.style.transition = `opacity ${duration}ms ease, transform ${duration}ms cubic-bezier(0.16, 1, 0.3, 1), left 0.3s ease-out, top 0.3s ease-out`;
        this.style.opacity = '1';
        this.style.transform = 'translate3d(0, 0, 0)';

        setTimeout(() => {
          this.style.transition = 'opacity 0.6s ease, left 0.3s ease-out, top 0.3s ease-out';
          this.style.transform = 'translate3d(0, 0, 0)';
          
          this.offsetHeight; 

          requestAnimationFrame(() => {
            this.classList.add('is-floating');
            this.style.setProperty('--float-dur', `${5 + Math.random() * 3}s`);
            this.style.setProperty('--float-del', `${Math.random() * -5}s`);
            this.style.setProperty('--float-offset', `${-10 - Math.random() * 10}px`);
          });
        }, duration);

      }, delay);
    }
  }

  customElements.define('floating-element', FloatingElement);
}

/********************************
 * bl_flex-card.liquid
 ********************************/
if (!customElements.get('bl-flex-card')) {
  class BlFlexCard extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.bl-flex_card__card');
      this.isMobileScrollInit = false;
      // "Slower Animation" section setting: on mobile the page stops at the cards
      // and one scroll gesture expands the next card (see the stepper below).
      this.slowAnimation = this.hasAttribute('slow-animation');

      // Bind methods
      this.handleResize = this.handleResize.bind(this);
      this.scrollHandler = this.scrollHandler.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.onStepScroll = this.onStepScroll.bind(this);
      this.onStepTouchStart = this.onStepTouchStart.bind(this);
      this.onStepTouchMove = this.onStepTouchMove.bind(this);
      this.onStepWheel = this.onStepWheel.bind(this);
      this.onStepKey = this.onStepKey.bind(this);

      // Desktop Hover Listeners
      this.cards.forEach(card => {
        card.addEventListener('mouseenter', () => this.handleMouseEnter(card));
        card.addEventListener('mouseleave', this.handleMouseLeave);
      });
      
      window.addEventListener('resize', this.handleResize);
      this.handleResize(); // Init on load
    }
    
    handleResize() {
      if (window.innerWidth <= 999) {
        this.initMobileScroll();
        this.measureContents();
      } else {
        this.destroyMobileScroll();
      }
    }

    /* ==============================
       DESKTOP: Same Row Sibling Logic
    ============================== */
    handleMouseEnter(hoveredCard) {
      if (window.innerWidth < 1000 || hoveredCard.classList.contains('bl-flex_card__full_width_card')) return;
      
      const hoveredRect = hoveredCard.getBoundingClientRect();
      
      this.cards.forEach(card => {
        // If it's not the hovered card, and it's not a full width card
        if (card !== hoveredCard && !card.classList.contains('bl-flex_card__full_width_card')) {
          const cardRect = card.getBoundingClientRect();
          // Check if the top coordinates align (meaning they are in the exact same row)
          // 10px buffer handles sub-pixel rendering discrepancies
          if (Math.abs(cardRect.top - hoveredRect.top) < 10) {
            card.classList.add('is-sibling-hovered');
          }
        }
      });
    }

    handleMouseLeave() {
      this.cards.forEach(card => card.classList.remove('is-sibling-hovered'));
    }
    
    /* ==============================
       MOBILE: Center Scroll Tracker
    ============================== */
    // Feeds --bl-fc-content-h so the max-height transition covers the real
    // content height (scrollHeight ignores the collapsed max-height).
    measureContents() {
      this.cards.forEach((card) => {
        const content = card.querySelector('.bl-flex_card__content');
        if (content) card.style.setProperty('--bl-fc-content-h', content.scrollHeight + 'px');
      });
    }

    initMobileScroll() {
      if (this.isMobileScrollInit || this.cards.length === 0) return;
      this.isMobileScrollInit = true;
      this.measureContents();

      if (this.useStepper()) {
        this.initStepper();
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.scrollHandler();
    }

    // The theme editor and reduced-motion users keep the plain tracker: no scroll-jacking there.
    useStepper() {
      if (!this.slowAnimation) return false;
      if (window.Shopify && window.Shopify.designMode) return false;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onScroll() {
      if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = window.requestAnimationFrame(this.scrollHandler);
    }

    scrollHandler() {
      if (window.innerWidth >= 1000) return;
      
      const viewportCenter = window.innerHeight / 2;
      let closestCard = null;
      let minDistance = Infinity;

      this.cards.forEach(card => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.top + (rect.height / 2);
        const distance = Math.abs(viewportCenter - cardCenter);

        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
        }
      });

      if (closestCard && !closestCard.classList.contains('is-active')) {
        this.cards.forEach(c => c.classList.remove('is-active'));
        closestCard.classList.add('is-active');
      }
    }

    destroyMobileScroll() {
      if (this.isMobileScrollInit) {
        window.removeEventListener('scroll', this.onScroll);
        if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
        this.destroyStepper();
        this.isMobileScrollInit = false;
      }
      this.cards.forEach(card => card.classList.remove('is-active'));
    }

    /* ==============================
       MOBILE: Gesture Stepper ("Slower Animation")
       Modelled on bl_scrolling-module-v2: as the cards approach their resting
       line the page glides into place and locks; one gesture (swipe / wheel
       tick / arrow key) expands the next or previous card; the gesture past
       either end releases the page. Crossing back over the line re-locks on
       the card that was left active. Nothing is expanded until the page stops.

       The page does not scroll while locked: the wrapper is positioned so the
       stack fits with its tallest card expanded, so cards grow and shrink in
       place. Only a stack taller than the screen gets a one-directional nudge
       per step. That keeps the hide-on-scroll header still (it shows on any
       upward scroll) and avoids per-frame scroll work.
    ============================== */
    initStepper() {
      this.step = 0;
      this.locked = false;
      this.armed = true;
      this.busy = false;
      this.prevTop = null;
      this.touchY = null;
      this.touchDone = false;

      // Landing below the cards (reload, anchor): rest on the last card so
      // scrolling back up re-locks there.
      if (this.getBoundingClientRect().top < this.restingLine()) {
        this.step = this.cards.length - 1;
        this.renderStep();
      }

      window.addEventListener('scroll', this.onStepScroll, { passive: true });
    }

    destroyStepper() {
      if (this.locked) this.unlockStepper();
      window.removeEventListener('scroll', this.onStepScroll);
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      this.settleRaf = null;
    }

    stepCard() {
      return this.cards[this.step];
    }

    // Height a card gains when active: its content plus the 80px header/content gap.
    expansionOf(card) {
      const content = card.querySelector('.bl-flex_card__content');
      return (content ? content.scrollHeight : 0) + 80;
    }

    // Stack height with every card collapsed plus the tallest single expansion:
    // the most room any step will need.
    projectedStackHeight() {
      let height = 0;
      let maxExpansion = 0;
      this.cards.forEach((card) => {
        const expansion = this.expansionOf(card);
        height += card.offsetHeight - (card.classList.contains('is-active') ? expansion : 0);
        maxExpansion = Math.max(maxExpansion, expansion);
      });
      const gap = parseFloat(getComputedStyle(this).rowGap) || 0;
      return height + gap * (this.cards.length - 1) + maxExpansion;
    }

    stackFits() {
      return this.projectedStackHeight() <= window.innerHeight - 40;
    }

    // Resting position of the wrapper's top: centred when the projected stack
    // fits, else 20px from the top. `withHeader` also clears a visible header
    // (upward entry, where the theme has just shown it).
    restingLine(withHeader = false) {
      let minTop = 20;
      if (withHeader) {
        const header = document.querySelector('store-header');
        if (header) minTop = Math.max(minTop, header.getBoundingClientRect().bottom + 20);
      }
      return Math.max(minTop, (window.innerHeight - this.projectedStackHeight()) / 2);
    }

    renderStep() {
      this.cards.forEach((card, i) => card.classList.toggle('is-active', i === this.step));
    }

    stepTo(dir) {
      if (this.busy) return;
      const last = this.cards.length - 1;
      if (dir > 0) {
        if (this.step < last) { this.step++; this.slideStep(1); } else this.unlockStepper();
      } else {
        if (this.step > 0) { this.step--; this.slideStep(-1); } else this.unlockStepper();
      }
    }

    // One step: swap the active card and hold input for the CSS transition.
    slideStep(dir) {
      const STEP_MS = 650;
      this.busy = true;
      this.renderStep();
      if (this.stackFits()) {
        setTimeout(() => { this.busy = false; }, STEP_MS);
      } else {
        this.followStep(dir, STEP_MS, () => { this.busy = false; });
      }
    }

    // Tall stacks only: nudge the page in the step's direction so the active
    // card stays on screen while it expands. Never reverses, so the header
    // does not flip. Lenis runs while the position changes (stopped, it puts
    // overflow:hidden on <html> and clamps a scroll in flight) and is stopped
    // again once done.
    followStep(dir, duration, done) {
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      if (window.lenis) window.lenis.start();

      const t0 = performance.now();
      const frame = (now) => {
        const rect = this.stepCard().getBoundingClientRect();
        let need = 0;
        if (dir > 0) {
          // Bring the bottom up into view, but never push the top above the margin.
          need = Math.min(Math.max(0, rect.bottom + 20 - window.innerHeight), Math.max(0, rect.top - 20));
        } else {
          need = Math.min(0, rect.top - 20);
        }
        if (Math.abs(need) > 0.5) window.scrollBy(0, need * 0.25);

        if (now - t0 < duration) {
          this.settleRaf = window.requestAnimationFrame(frame);
        } else {
          this.settleRaf = null;
          if (window.lenis && this.locked) window.lenis.stop();
          done();
        }
      };
      this.settleRaf = window.requestAnimationFrame(frame);
    }

    // Eased scroll to an absolute position (manual rAF, see followStep for why
    // not behavior:'smooth' with Lenis).
    snapTo(target, done) {
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      const start = window.scrollY;
      const dist = target - start;
      if (Math.abs(dist) < 2) { done(); return; }
      const t0 = performance.now();
      const D = 400;
      const frame = (now) => {
        const p = Math.min((now - t0) / D, 1);
        window.scrollTo(0, start + dist * (1 - Math.pow(1 - p, 3)));
        if (p < 1) this.settleRaf = window.requestAnimationFrame(frame);
        else { this.settleRaf = null; done(); }
      };
      this.settleRaf = window.requestAnimationFrame(frame);
    }

    engageStepper(dir) {
      this.locked = true;
      this.armed = false;
      this.busy = true;
      this.addStepBlockers();
      this.renderStep();

      const line = this.restingLine(dir < 0);
      const target = window.scrollY + this.getBoundingClientRect().top - line;
      this.snapTo(target, () => {
        if (window.lenis) window.lenis.stop();
        // Entering downward the header must stay hidden. The snap normally moves
        // down (the band catches the cards before the line), but a fast fling
        // can overshoot and snap back up, which the theme reads as scrolling up.
        if (dir > 0) setTimeout(() => this.hideStoreHeader(), 100);
        this.busy = false;
      });
    }

    unlockStepper() {
      if (this.settleRaf) window.cancelAnimationFrame(this.settleRaf);
      this.settleRaf = null;
      this.removeStepBlockers();
      if (window.lenis) window.lenis.start();
      this.locked = false;
      this.armed = false;
      this.busy = false;
      this.prevTop = this.getBoundingClientRect().top;
    }

    hideStoreHeader() {
      const header = document.querySelector('store-header');
      if (header && header.hasAttribute('hide-on-scroll') && typeof header.hide === 'function') header.hide();
    }

    onStepScroll() {
      if (this.locked) return;

      // Engage a band ahead of the line so the glide finishes in the direction
      // the visitor was already scrolling.
      const BAND = 120;
      const top = this.getBoundingClientRect().top;
      const line = this.restingLine();

      if (this.prevTop === null) { this.prevTop = top; return; }

      // Right after a release the cards sit on the line; wait until they have
      // moved clearly away before a crossing can lock again.
      if (!this.armed) {
        if (Math.abs(top - line) > BAND + 40) this.armed = true;
        this.prevTop = top;
        return;
      }

      const enteredScrollingDown = this.prevTop > line + BAND && top <= line + BAND;
      const enteredScrollingUp = this.prevTop < line - BAND && top >= line - BAND;
      this.prevTop = top;

      const last = this.cards.length - 1;
      if (enteredScrollingDown && this.step < last) this.engageStepper(1);
      else if (enteredScrollingUp && this.step > 0) this.engageStepper(-1);
    }

    onStepTouchStart(e) {
      this.touchY = e.touches[0].clientY;
      this.touchDone = false;
    }

    onStepTouchMove(e) {
      e.preventDefault();
      if (this.touchDone || this.touchY === null) return;
      const dy = e.touches[0].clientY - this.touchY;
      if (Math.abs(dy) > 30) {
        this.touchDone = true;
        this.stepTo(dy < 0 ? 1 : -1);
      }
    }

    onStepWheel(e) {
      e.preventDefault();
      if (Math.abs(e.deltaY) < 4) return;
      this.stepTo(e.deltaY > 0 ? 1 : -1);
    }

    onStepKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') { e.preventDefault(); this.stepTo(1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); this.stepTo(-1); }
    }

    addStepBlockers() {
      window.addEventListener('touchstart', this.onStepTouchStart, { passive: true });
      window.addEventListener('touchmove', this.onStepTouchMove, { passive: false });
      window.addEventListener('wheel', this.onStepWheel, { passive: false });
      window.addEventListener('keydown', this.onStepKey, true);
    }

    removeStepBlockers() {
      window.removeEventListener('touchstart', this.onStepTouchStart);
      window.removeEventListener('touchmove', this.onStepTouchMove);
      window.removeEventListener('wheel', this.onStepWheel);
      window.removeEventListener('keydown', this.onStepKey, true);
    }
    
    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroyMobileScroll();
    }
  }
  
  customElements.define('bl-flex-card', BlFlexCard);
}

/********************************
 * bl_number-counter.liquid
 ********************************/
if (!customElements.get('bl-number-cards')) {
  customElements.define('bl-number-cards', class extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.bl-number_card');
      this.counters = this.querySelectorAll('bl-number-counter');
    }

    connectedCallback() {
      this.counters.forEach((counter, index) => {
        const originalText = counter.textContent.trim();
        const targetVal = parseFloat(originalText.replace(/,/g, ''));
        
        if (!isNaN(targetVal)) {
          counter.dataset.target = targetVal;
          counter.dataset.hasComma = originalText.includes(',');
          counter.dataset.decimals = originalText.includes('.') ? originalText.split('.')[1].length : 0;
          counter.textContent = '0';
        }
        if(this.cards[index]) {
          this.cards[index].style.transitionDelay = `${index * 0.15}s`;
        }
      });

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.add('is-revealed');
            this.startCounting();
            observer.unobserve(this);
          }
        });
      }, { 
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px"
      });

      this.observer.observe(this);
    }

    startCounting() {
      const duration = 2500;

      this.counters.forEach((counter, index) => {
        const target = parseFloat(counter.dataset.target);
        if (isNaN(target)) return;
        
        const decimals = parseInt(counter.dataset.decimals);
        const hasComma = counter.dataset.hasComma === 'true';

        const formatNumber = (num) => {
          if (hasComma) {
            return num.toLocaleString('en-US', {
              minimumFractionDigits: decimals,
              maximumFractionDigits: decimals
            });
          }
          return num.toFixed(decimals);
        };

        setTimeout(() => {
          let startTimestamp = null;

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            
            const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            
            const currentVal = easeProgress * target;
            counter.textContent = formatNumber(currentVal);

            if (progress < 1) {
              window.requestAnimationFrame(step);
            } else {
              counter.textContent = formatNumber(target);
            }
          };

          window.requestAnimationFrame(step);
        }, index * 150);
      });
    }
  });
}

/********************************************************
 * bl_parallax-banner.liquid
 ********************************************************/
if (!customElements.get('bl-parallax-banner')) {
  class BlParallaxBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.closest('.bl-scroll-track');
      this.slides = Array.from(this.querySelectorAll('.bl-parallax_banner__image_wrapper'));
      
      if (this.slides.length < 2 || !this.track) return;

      this.slides.forEach((slide, index) => {
        slide.style.zIndex = index;
      });

      this.windowWidth = window.innerWidth;

      this.updateDimensions = () => {
        const trackRect = this.track.getBoundingClientRect();
        this.trackAbsoluteTop = trackRect.top + window.scrollY;
        this.trackHeight = trackRect.height;
        this.maxScroll = this.trackHeight - window.innerHeight;
      };

      this.updateDimensions();
      this.onResize = () => {
        if (window.innerWidth !== this.windowWidth) {
          this.windowWidth = window.innerWidth;
          this.updateDimensions();
        }
      };
      window.addEventListener('resize', this.onResize, { passive: true });

      this.lastScrollY = -1;
      
      this.updateFrame = () => {
        if (this.lastScrollY === window.scrollY) {
          this.rafId = requestAnimationFrame(this.updateFrame);
          return;
        }
        this.lastScrollY = window.scrollY;

        const currentTrackTop = this.trackAbsoluteTop - window.scrollY;
        let progress = -currentTrackTop / this.maxScroll;
        progress = Math.max(0, Math.min(1, progress));

        const totalSlides = this.slides.length;
        const progressPerSlide = 1 / (totalSlides - 1);
        const dwellRatio = 0.35; 

        this.slides.forEach((slide, index) => {
          const slideStart = (index - 1) * progressPerSlide;
          const slideEnd = index * progressPerSlide;
          const segmentLength = slideEnd - slideStart;
          const slideActiveStart = slideStart + (segmentLength * dwellRatio);
          
          const nextSlideStart = index * progressPerSlide;
          const nextSlideEnd = (index + 1) * progressPerSlide;
          const nextSegmentLength = nextSlideEnd - nextSlideStart;
          const nextActiveStart = nextSlideStart + (nextSegmentLength * dwellRatio);

          if (index > 0) {
            if (progress <= slideActiveStart) {
              slide.style.transform = `translate3d(0, 100%, 0)`;
            } else if (progress >= slideEnd) {
              slide.style.transform = `translate3d(0, 0%, 0)`;
            } else {
              const slideProgress = (progress - slideActiveStart) / (slideEnd - slideActiveStart);
              const yPos = 100 - (slideProgress * 100);
              slide.style.transform = `translate3d(0, ${yPos}%, 0)`;
            }
          }
          if (index < totalSlides - 1) {
            if (progress >= nextActiveStart && progress <= nextSlideEnd) {
              const fadeProgress = (progress - nextActiveStart) / (nextSlideEnd - nextActiveStart);
              slide.style.opacity = 1 - (fadeProgress * 0.6);
            } else if (progress > nextSlideEnd) {
              slide.style.opacity = 0.4;
            } else {
              slide.style.opacity = 1;
            }
          }

          const slideMidPoint = slideActiveStart + ((slideEnd - slideActiveStart) * 0.5);
          const nextMidPoint = nextActiveStart + ((nextSlideEnd - nextActiveStart) * 0.5);
          
          const isRevealed = index === 0 ? true : progress >= slideMidPoint;
          const isCoveredByNext = index < totalSlides - 1 && progress >= nextMidPoint;
          
          if (isRevealed && !isCoveredByNext) {
            if (!slide.classList.contains('is-active')) slide.classList.add('is-active');
          } else {
            if (slide.classList.contains('is-active')) slide.classList.remove('is-active');
          }
        });

        clearTimeout(this.snapTimeout);
        this.snapTimeout = setTimeout(() => {
          if (progress > 0 && progress < 1) {
            const exactSlide = progress / progressPerSlide;
            const nearestSlide = Math.round(exactSlide); 
            
            if (Math.abs(exactSlide - nearestSlide) > 0.02) {
              const targetProgress = nearestSlide * progressPerSlide;
              const targetScrollTop = this.trackAbsoluteTop + (targetProgress * this.maxScroll);
              
              if (window.lenis) {
                window.lenis.scrollTo(targetScrollTop, { lerp: 0.1 });
              } else {
                window.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
              }
            }
          }
        }, 350);

        this.rafId = requestAnimationFrame(this.updateFrame);
      };

      this.rafId = requestAnimationFrame(this.updateFrame);
    }
    
    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      clearTimeout(this.snapTimeout);
      window.removeEventListener('resize', this.onResize);
    }
  }
  customElements.define('bl-parallax-banner', BlParallaxBanner);
}

/********************************************************
 * bl-multi-image_with_usp.liquid
 ********************************************************/
class AutoLoopImages extends HTMLElement {
  constructor() {
    super();
    this._imageList = this.querySelector("multiple-images-with-text-image-list");
    this._timer = null;
    this._speed = 4000;
  }

  connectedCallback() {
    // Only run if there is more than 1 image
    if (!this._imageList || this._imageList.children.length <= 1) return;

    // Use IntersectionObserver so it only slides when user sees it
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._startAutoplay();
        } else {
          this._stopAutoplay();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(this);

    // Pause animation when user hovers over the USPs/Content
    this.addEventListener('mouseenter', () => this._stopAutoplay());
    this.addEventListener('mouseleave', () => this._startAutoplay());
  }

  _startAutoplay() {
    this._stopAutoplay();
    this._timer = setInterval(() => {
      // We call the 'next' method that exists on the original MultipleImagesWithTextImageList component
      if (this._imageList && typeof this._imageList.next === 'function') {
        this._imageList.next();
      }
    }, this._speed);
  }

  _stopAutoplay() {
    if (this._timer) clearInterval(this._timer);
  }

  disconnectedCallback() {
    this._stopAutoplay();
  }
}

// Define the custom element
if (!window.customElements.get("auto-loop-images")) {
  window.customElements.define("auto-loop-images", AutoLoopImages);
}

/********************************
 * Cart gifts: subscription welcome offer and Founder's Edition gift
 ********************************/
(function () {
  const TARGET_IDS = ['15973231329361', '15973238734929'];
  const PROP_KEY = '_Subscription_Welcome_Offer';
  let _busy = false;

  // Added based on which specific variant of the subscription product is in the cart
  const VARIANT_WELCOME_MAP = {
    '60029879451729': [{ variantId: '60071500054609' }],
    '60029879484497': [{ variantId: '60071500054609' }],
    '60029879582801': [{ variantId: '60071500054609' }],
    '60029879615569': [{ variantId: '60071500054609' }],
    '60029888069713': [{ variantId: '60071500054609' }],
    '60029888102481': [{ variantId: '60071500054609' }],
    '60029888135249': [{ variantId: '60071500054609' }],
    '60029888168017': [{ variantId: '60071500054609' }]
  };

  // ---- CSS ----
  const _style = document.createElement('style');
  _style.textContent =
    'cart-drawer,.shopify-section--main-cart{position:relative}' +
    'cart-drawer.bl-cart-loading,.shopify-section--main-cart.bl-cart-loading{pointer-events:none}' +
    '.bl-cart-overlay{position:absolute;inset:0;z-index:9999;background:rgb(var(--background) / .78);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px}' +
    '.bl-cart-overlay__spinner{width:32px;height:32px;border:3px solid rgb(var(--text-color) / .15);border-top-color:rgb(var(--text-color));border-radius:50%;animation:bl-spin .7s linear infinite}' +
    '@keyframes bl-spin{to{transform:rotate(360deg)}}' +
    '.bl-cart-overlay__text{font-size:13px;color:rgb(var(--text-color));margin:0}' +
    'line-item[data-bl-gift] line-item-quantity{display:none!important}';
  document.head.appendChild(_style);

  // ---- Overlay ----
  // Cover both the cart drawer (popover/drawer cart) and the standalone cart page
  function getCartContainers() {
    return Array.from(document.querySelectorAll('cart-drawer, .shopify-section--main-cart'));
  }

  function isOverlayNode(node) {
    return node && node.nodeType === 1 && node.classList && node.classList.contains('bl-cart-overlay');
  }

  // Hold count — while > 0 the MutationObserver will not auto-hide the overlay.
  // Used by the welcome-offer flow so the overlay survives the multiple fetches
  // and the final cart re-render.
  let _overlayHold = 0;

  function showCartLoading() {
    getCartContainers().forEach(function (target) {
      if (target.querySelector(':scope > .bl-cart-overlay')) return;
      target.classList.add('bl-cart-loading');
      const o = document.createElement('div');
      o.className = 'bl-cart-overlay';
      o.innerHTML = '<div class="bl-cart-overlay__spinner"></div><p class="bl-cart-overlay__text">Updating cart…</p>';
      target.appendChild(o);
    });
  }

  function hideCartLoading() {
    getCartContainers().forEach(function (target) {
      target.classList.remove('bl-cart-loading');
      target.querySelector(':scope > .bl-cart-overlay')?.remove();
    });
  }

  // Wait for the next real (non-overlay) content mutation on a cart container,
  // so the welcome-offer flow can keep the overlay visible until the cart
  // drawer/cart page has actually re-rendered with the final state.
  function awaitCartContentChange(timeoutMs) {
    if (timeoutMs == null) timeoutMs = 5000;
    return new Promise(function (resolve) {
      const containers = getCartContainers();
      if (!containers.length) return resolve();
      let settled = false;
      const observers = [];
      const finish = function () {
        if (settled) return;
        settled = true;
        observers.forEach(function (o) { o.disconnect(); });
        resolve();
      };
      containers.forEach(function (c) {
        const obs = new MutationObserver(function (mutations) {
          const real = mutations.some(function (m) {
            const added = Array.from(m.addedNodes).some(function (n) { return !isOverlayNode(n); });
            const removed = Array.from(m.removedNodes).some(function (n) { return !isOverlayNode(n); });
            return added || removed;
          });
          if (real) finish();
        });
        obs.observe(c, { childList: true, subtree: true });
        observers.push(obs);
      });
      setTimeout(finish, timeoutMs);
    });
  }

  // ---- MutationObserver — re-hide overlay after cart container re-renders ----
  // Filter out mutations that only involve our own overlay node, otherwise
  // appending the overlay would trigger an immediate hide. Also skip while the
  // welcome-offer flow has the overlay explicitly held.
  function setupCartObservers() {
    getCartContainers().forEach(function (container) {
      const observer = new MutationObserver(function (mutations) {
        if (_overlayHold > 0) return;
        const hasRealChange = mutations.some(function (m) {
          const added = Array.from(m.addedNodes).some(function (n) { return !isOverlayNode(n); });
          const removed = Array.from(m.removedNodes).some(function (n) { return !isOverlayNode(n); });
          return added || removed;
        });
        if (hasRealChange) hideCartLoading();
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  // Show overlay on every theme-driven cart update (manual qty change, remove
  // link, product form add). Both code paths in theme.js dispatch this event
  // synchronously right before the fetch starts.
  function bindCartUpdateTriggers() {
    document.addEventListener('cart:prepare-bundled-sections', showCartLoading);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupCartObservers();
      bindCartUpdateTriggers();
    });
  } else {
    setupCartObservers();
    bindCartUpdateTriggers();
  }

  // ---- Helpers ----
  function isSubscriptionItem(item) {
    if (!TARGET_IDS.includes(String(item.product_id))) return false;
    const a = item.selling_plan_allocation;
    return !!(a && a.selling_plan &&
      typeof a.selling_plan.name === 'string' &&
      a.selling_plan.name.toLowerCase().includes('subscription'));
  }

  function checkCartItems(cart) {
    cart.items.forEach(function (item) {
      if (!TARGET_IDS.includes(String(item.product_id))) return;
    });
  }

  // A gift item carries the hidden property. We check for property *presence*
  // (not value), since each gift add uses a unique property value to guarantee
  // Shopify never merges it with a manual add.
  function isGiftItem(item) {
    return !!(item.properties && item.properties[PROP_KEY]);
  }

  // ---- Main handler ----
  // Reconcile gift items against current subscription items every cart change.
  // The needed quantity for each gift variant is summed across subscription
  // lines (multiplied by each line's quantity). Existing gift lines that are
  // orphaned (no matching subscription left) or have a stale quantity are
  // removed; missing gifts are added.
  async function handleCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    checkCartItems(cart);

    if (_busy) return;

    // Build the needed gift map from current subscription items.
    const neededMap = {};
    cart.items.forEach(function (item) {
      if (!isSubscriptionItem(item)) return;
      const mapped = VARIANT_WELCOME_MAP[String(item.variant_id)];
      if (!mapped) return;
      mapped.forEach(function (w) {
        const qty = (w.quantity || 1) * (item.quantity || 1);
        neededMap[w.variantId] = (neededMap[w.variantId] || 0) + qty;
      });
    });

    // Group existing gift lines by variant_id (there can be multiple lines per
    // variant because each add uses a unique property tag).
    const existingGifts = {};
    cart.items.forEach(function (item) {
      if (!isGiftItem(item)) return;
      const v = String(item.variant_id);
      (existingGifts[v] = existingGifts[v] || []).push(item);
    });

    const changes = [];
    const toAdd = [];

    // For each existing gift variant, decide whether to keep, remove, or rebuild.
    Object.keys(existingGifts).forEach(function (variantId) {
      const items = existingGifts[variantId];
      const needed = neededMap[variantId] || 0;
      const totalExisting = items.reduce(function (s, i) { return s + i.quantity; }, 0);

      if (items.length === 1 && needed === totalExisting) return;

      // Otherwise zero out all existing lines and re-add a single consolidated
      // line if still needed. Simpler than trying to patch quantities in place,
      // and avoids leaving multiple split lines after qty changes.
      items.forEach(function (i) { changes.push({ key: i.key, quantity: 0 }); });
      if (needed > 0) toAdd.push({ variantId: variantId, quantity: needed });
    });

    // Variants needed that aren't in cart yet.
    Object.keys(neededMap).forEach(function (variantId) {
      if (existingGifts[variantId]) return;
      if (neededMap[variantId] > 0) {
        toAdd.push({ variantId: variantId, quantity: neededMap[variantId] });
      }
    });

    if (!changes.length && !toAdd.length) return;

    _busy = true;
    _overlayHold++;
    showCartLoading();
    try {
      for (const change of changes) {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: change.key, quantity: change.quantity })
        });
      }

      if (toAdd.length) {
        // Unique value per add prevents Shopify from merging the gift line item
        // with any customer-added copy of the same variant. The 'YES' prefix
        // keeps it readable in the Shopify admin.
        const items = toAdd.map(function (entry) {
          const uniqueTag = 'YES-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
          return { id: Number(entry.variantId), quantity: entry.quantity, properties: { [PROP_KEY]: uniqueTag } };
        });

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      await awaitCartContentChange();
    } finally {
      _busy = false;
      _overlayHold = Math.max(0, _overlayHold - 1);
      hideCartLoading();
    }
  }

  // ---- Founder's Edition gift ----
  // window.blFounderGift comes from snippets/bl-founder-gift.liquid while Theme settings → Founder's Edition gift →
  // "Theme adds the gift to the cart" is on. One gift line while the cart holds a Diapers Bundle (any Bundle variant of
  // the Bundle product) and the shopper qualifies (guest, or logged in with no orders); no gift line otherwise. Runs on
  // every cart change, on cart refreshes and on page load, so adding or removing the Bundle, logging in, and changing
  // the gift line by any other means (its quantity box and remove link are not rendered) all end up corrected. The
  // gift's $0 price comes from the Shopify automatic discount, not from here.
  const FOUNDER = window.blFounderGift;
  let _founderBusy = false;
  let _founderPending = false;
  let _founderAddFailed = false;
  let _founderWrites = [];

  function isFounderTrigger(item) {
    return item.handle === FOUNDER.triggerHandle && item.variant_id !== FOUNDER.variantId &&
      (item.options_with_values || []).some(function (o) { return o.value === FOUNDER.triggerValue; });
  }

  async function checkFounderGift(cart) {
    if (!FOUNDER) return;
    if (_founderBusy) {
      _founderPending = true;
      return;
    }
    if (!cart || !Array.isArray(cart.items)) {
      cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    }

    const lines = cart.items.filter(function (item) { return item.variant_id === FOUNDER.variantId; });
    const have = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
    const wanted = FOUNDER.eligible && FOUNDER.available && cart.items.some(isFounderTrigger) ? 1 : 0;
    if (have === wanted && lines.length <= 1) return;
    if (wanted && !lines.length && _founderAddFailed) return;

    // Something else putting the gift straight back (e.g. the Selly gift offer left on) would make the two fight:
    // stop after 4 corrections in 30 seconds.
    const now = Date.now();
    _founderWrites = _founderWrites.filter(function (t) { return now - t < 30000; });
    if (_founderWrites.length >= 4) {
      console.warn('Founder\'s Edition gift: the cart keeps changing back, so the theme stopped correcting it. Is the Selly gift offer still on?');
      return;
    }
    _founderWrites.push(now);

    _founderBusy = true;
    _overlayHold++;
    showCartLoading();
    try {
      if (wanted && !lines.length) {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: FOUNDER.variantId, quantity: 1 }] })
        });
        // Sold out since the page loaded: leave it for this page.
        if (!response.ok) _founderAddFailed = true;
      } else {
        // Keep one line at quantity 1 (the Selly line while one is left, so the two never fight) and drop the rest.
        const keep = wanted ? (lines.find(function (i) { return i.properties && i.properties._gift; }) || lines[0]) : null;
        const updates = {};
        lines.forEach(function (i) { updates[i.key] = i === keep ? 1 : 0; });
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      }

      // The cart page re-renders by reloading (as theme.js does after a quantity change).
      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      await awaitCartContentChange();
    } finally {
      _founderBusy = false;
      _overlayHold = Math.max(0, _overlayHold - 1);
      hideCartLoading();
      if (_founderPending) {
        _founderPending = false;
        checkFounderGift();
      }
    }
  }

  document.addEventListener('cart:change', function (event) {
    handleCart(event.detail && event.detail.cart);
    checkFounderGift(event.detail && event.detail.cart);
  });

  // cart:refresh carries no cart (other code, and the gift flows above, send it after changing the cart).
  document.addEventListener('cart:refresh', function () {
    checkFounderGift();
  });

  fetch(window.Shopify.routes.root + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      handleCart(cart);
      checkFounderGift(cart);
    });
})();

/********************************
 * Lenis – let drawers scroll natively, pause page scroll while one is open
 ********************************/
(function () {
  // data-lenis-prevent tells Lenis to bail out of wheel events whose target
  // sits inside this element, so the drawer body's overflow-y: auto can do
  // its native scroll. lenis.stop() alone isn't enough — Lenis still
  // preventDefault()s wheel events even when stopped.
  function markDrawersForLenis() {
    document.querySelectorAll('.drawer').forEach(function (drawer) {
      if (!drawer.hasAttribute('data-lenis-prevent')) {
        drawer.setAttribute('data-lenis-prevent', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDrawersForLenis);
  } else {
    markDrawersForLenis();
  }

  // Pause Lenis page scroll while any drawer is open.
  var openDrawerCount = 0;

  document.addEventListener('toggle', function (e) {
    if (!e.target.classList || !e.target.classList.contains('drawer')) return;
    if (!window.lenis) return;

    if (e.target.hasAttribute('open')) {
      openDrawerCount++;
      if (openDrawerCount === 1) window.lenis.stop();
    } else {
      openDrawerCount = Math.max(0, openDrawerCount - 1);
      if (openDrawerCount === 0) window.lenis.start();
    }
  });
})();
/********************************
 * Add-to-cart label by purchase option
 ********************************/
// <buy-buttons data-atc-label-onetime="…" data-atc-label-subscription="…"> (rendered by
// snippets/buy-buttons.liquid and the product page sticky bar) carries both labels for the
// current variant; product-rerender swaps the element on variant change, so the labels stay
// current. This picks the one matching the purchase option currently selected:
//  - Product page: the Recharge widget (<recharge-subscription-widget>, shadow DOM). Its
//    "purchaseOption" radio group is the source of truth, read the same way the welcome-kit
//    code in layout/theme.liquid does. The widget raises no DOM event outside its shadow root,
//    so its radios are bound directly once rendered and the page is also polled at a low rate
//    to catch async renders and Lit re-renders.
//  - Product Tabs V2: bl-selling-plan-picker writes the `selling_plan` field on the form and
//    fires `selling-plan:change`.
// Console helper: blAtcLabels.debug() dumps what the script sees for every labelled button.
(function () {
  const SELECTOR = 'buy-buttons[data-atc-label-onetime]';
  const OPTION_INPUTS = 'input[name="purchaseOption"], input.rc-purchase-option__input, [part~="rc-purchase-option__input"]';
  const POLL_MS = 300;
  let reported = false;

  // The widget nests components (e.g. <rc-selling-plans>) with their own shadow roots.
  function shadowRoots(root, out = []) {
    if (!root) return out;
    out.push(root);
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) shadowRoots(el.shadowRoot, out);
    });
    return out;
  }

  // The product form holds a hidden variant input named "id", and named form controls shadow
  // built-in form properties, so `form.id` is that input, not the id string (theme.js relies on
  // this with `this.id.value`). Always read the attribute.
  function formId(form) {
    return form.getAttribute('id');
  }

  // The Recharge app block renders in the same section as the product form it belongs to.
  function widgetFor(form) {
    const rerender = document.querySelector(`product-rerender[observe-form="${formId(form)}"]`);
    const scope = (rerender || form).closest('.shopify-section');
    return scope ? scope.querySelector('recharge-subscription-widget') : null;
  }

  // Input value plus every ancestor class inside the shadow root, for markup that only tells
  // one-time from subscription on a wrapper (rc-selection__onetime, rc-purchase-option__subscription).
  function hintFor(input) {
    const parts = [input.value, input.className];
    for (let el = input.parentElement; el; el = el.parentElement) parts.push(el.className || '');
    return parts.join(' ');
  }

  // 'subscription' | 'onetime' | null while the widget has not rendered its options yet.
  function widgetSelection(widget) {
    for (const root of shadowRoots(widget.shadowRoot)) {
      // Same rule as the welcome kit: the "subscription" radio's checked state is the selection.
      const subscription = root.querySelector('input[name="purchaseOption"][value="subscription"]');
      if (subscription) return subscription.checked ? 'subscription' : 'onetime';

      for (const input of root.querySelectorAll(OPTION_INPUTS)) {
        if (!input.checked) continue;
        const hint = hintFor(input);
        if (/subscription/i.test(hint)) return 'subscription';
        if (/onetime|one-time|one_time/i.test(hint)) return 'onetime';
      }
    }
    return null;
  }

  function bindWidget(widget) {
    for (const root of shadowRoots(widget.shadowRoot)) {
      root.querySelectorAll(OPTION_INPUTS).forEach((input) => {
        if (input._blAtcBound) return;
        input._blAtcBound = true;
        input.addEventListener('change', applyAll);
      });
    }
  }

  function sellingPlanFields(form) {
    const field = form.elements['selling_plan'];
    if (!field) return [];
    return field instanceof RadioNodeList ? Array.from(field) : [field];
  }

  // true / false when the page tells us, null when it does not (the server label stays).
  function subscriptionSelected(form) {
    const widget = widgetFor(form);
    if (widget) {
      bindWidget(widget);
      const selection = widgetSelection(widget);
      if (selection) return selection === 'subscription';
    }

    const fields = sellingPlanFields(form);
    if (fields.length) return fields.some((el) => !el.disabled && el.value !== '');

    return null;
  }

  // <button is="custom-button"> moves its label into a child <div> and appends a loader span;
  // write into that div so the loading animation keeps working.
  function labelTarget(button) {
    return button._contentElement || Array.from(button.children).find((el) => el.tagName === 'DIV') || button;
  }

  function applyLabels(form) {
    const id = form ? formId(form) : null;
    if (!id) return;

    const selected = subscriptionSelected(form);
    if (selected === null) return;

    document.querySelectorAll(`${SELECTOR}[form="${id}"]`).forEach((buyButtons) => {
      const label = selected ? buyButtons.dataset.atcLabelSubscription : buyButtons.dataset.atcLabelOnetime;
      const button = buyButtons.querySelector('button[type="submit"]');

      // Sold out / unavailable buttons are disabled and keep their state label.
      if (!label || !button || button.disabled) return;

      const target = labelTarget(button);
      // The diaper bundle cards (snippets/variant-picker-diaper-cards.liquid) append the selected card's price as
      // <span class="bl-atc-price"> inside the label; compare and rewrite the text without touching that span.
      const priceEl = target.querySelector('.bl-atc-price');
      const current = priceEl ? target.textContent.replace(priceEl.textContent, '').trim() : target.textContent.trim();
      if (current !== label) {
        target.textContent = label;
        if (priceEl) target.append(priceEl);
      }
    });
  }

  function applyAll() {
    try {
      const forms = new Set();
      document.querySelectorAll(SELECTOR).forEach((el) => {
        const form = document.forms[el.getAttribute('form')];
        if (form) forms.add(form);
      });
      forms.forEach(applyLabels);
    } catch (error) {
      if (!reported) console.warn('[bl-atc-labels]', error);
      reported = true;
    }
  }

  function formFrom(event) {
    const target = event.target;
    if (target instanceof HTMLFormElement) return target;
    return target?.form || target?.closest?.('form') || null;
  }

  // Product Tabs V2 picker, and any light-DOM selling plan control.
  document.addEventListener('selling-plan:change', (event) => applyLabels(formFrom(event)));
  document.addEventListener('change', (event) => {
    if (event.target?.name === 'selling_plan') applyLabels(formFrom(event));
  }, true);

  // Variant change: product-rerender has just replaced <buy-buttons> with the server version,
  // which only knows the preselected state.
  document.addEventListener('variant:change', (event) => applyLabels(formFrom(event)));

  // Low-rate poll for the Recharge widget: async first render, Lit re-renders (new radios to
  // bind) and programmatic `selling_plan` updates raise no event we can hook.
  setInterval(() => {
    if (document.visibilityState === 'visible' && document.querySelector(SELECTOR)) applyAll();
  }, POLL_MS);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  window.blAtcLabels = {
    apply: applyAll,
    debug() {
      return Array.from(document.querySelectorAll(SELECTOR)).map((el) => {
        const form = document.forms[el.getAttribute('form')];
        const widget = form ? widgetFor(form) : null;
        const inputs = widget ? shadowRoots(widget.shadowRoot).flatMap((root) => Array.from(root.querySelectorAll('input'))) : [];
        return {
          form: el.getAttribute('form'),
          formFound: !!form,
          widgetFound: !!widget,
          widgetShadowRoot: !!(widget && widget.shadowRoot),
          widgetInputs: inputs.map((i) => `${i.type} name=${i.name} value=${i.value} checked=${i.checked} class=${i.className}`),
          widgetSelection: widget ? widgetSelection(widget) : null,
          sellingPlanFields: form ? sellingPlanFields(form).map((f) => `value=${f.value} disabled=${f.disabled}`) : [],
          selected: form ? subscriptionSelected(form) : null,
          labels: { onetime: el.dataset.atcLabelOnetime, subscription: el.dataset.atcLabelSubscription },
          buttonText: el.querySelector('button[type="submit"]')?.textContent.trim() || null
        };
      });
    }
  };
})();

/********************************
 * Quick buy drawer – run its scripts, prefetch Frequently Bought Together
 ********************************/
// The theme's <quick-buy-drawer> (assets/theme.js, QuickBuyDrawer) fetches the product page on first open and inserts
// its <template id="quick-buy-content"> through DOMParser, so the inline scripts of that content never run. The diaper
// bundle cards (snippets/variant-picker-diaper-cards.liquid, rendered by snippets/product-quick-buy-diaper.liquid)
// need theirs, so show() is replaced by the same steps with a contextual fragment, whose scripts run when inserted.
// The content is cached for a few minutes and prefetched for the Frequently Bought Together rows
// (snippets/sg-complementary-products.liquid) when the list nears the viewport or an Add button is hovered or focused,
// so the drawer opens at once. A cached copy is used for one open only: after an add the theme clears _hasLoaded and
// the next open fetches again (current stock).
// Loading state: a prefetched copy opens without one. Otherwise the Add button shows the theme's loading dots for at
// least BUSY_MIN_MS: <button is="custom-button"> (theme.js) animates the label out and the dots in over 0.3 s, and
// switching aria-busy back before that mixes the two animations, leaving the label sliding up from below and no dots.
(function () {
  const CACHE_MS = 5 * 60 * 1000;
  const BUSY_MIN_MS = 350;
  const FBT_BUTTON = '.product-info__complementary-products [aria-controls^="quick-buy-horizontal-"]';
  const cache = new Map();

  // An entry keeps its markup in `html` once loaded, so an open can tell a ready copy from one still on its way.
  function load(handle) {
    const hit = cache.get(handle);
    if (hit && Date.now() - hit.at < CACHE_MS) return hit;

    const entry = { at: Date.now(), html: null };
    entry.promise = fetch(`${window.Shopify.routes.root}products/${handle}`)
      .then((response) => response.text())
      .then((html) => {
        const template = new DOMParser().parseFromString(html, 'text/html').getElementById('quick-buy-content');
        if (!template) throw new Error(`No quick buy content for ${handle}`);
        return (entry.html = template.innerHTML);
      });
    entry.promise.catch(() => cache.delete(handle));
    cache.set(handle, entry);
    return entry;
  }

  customElements.whenDefined('quick-buy-drawer').then(() => {
    const QuickBuyDrawer = customElements.get('quick-buy-drawer');
    const drawerShow = Object.getPrototypeOf(QuickBuyDrawer.prototype).show;

    QuickBuyDrawer.prototype.show = async function () {
      if (!this._hasLoaded) {
        const handle = this.getAttribute('handle');
        const entry = load(handle);
        let html = entry.html;

        if (html === null) {
          const controls = [this, ...this.controls];
          const started = Date.now();
          controls.forEach((control) => control.setAttribute('aria-busy', 'true'));
          try {
            html = await entry.promise;
          } catch (error) {
            controls.forEach((control) => control.setAttribute('aria-busy', 'false'));
            // Same outcome as a failed theme fetch would deserve: the product page itself.
            window.location.href = `${window.Shopify.routes.root}products/${handle}`;
            return;
          }
          await new Promise((resolve) => setTimeout(resolve, Math.max(0, BUSY_MIN_MS - (Date.now() - started))));
          controls.forEach((control) => control.setAttribute('aria-busy', 'false'));
        }
        cache.delete(handle);
        const fragment = document.createRange().createContextualFragment(html);
        fragment.querySelectorAll('noscript').forEach((noScript) => noScript.remove());
        this.style.display = 'block';
        this.replaceChildren(fragment);
        window.Shopify.PaymentButton?.init();
        this._hasLoaded = true;
      }
      this.style.display = 'block';
      return drawerShow.call(this);
    };
  });

  function drawerFor(button) {
    return button ? document.getElementById(button.getAttribute('aria-controls')) : null;
  }

  function prefetch(drawer) {
    const handle = drawer && !drawer._hasLoaded && drawer.getAttribute('handle');
    if (handle) load(handle).promise.catch(() => {});
  }

  const saveData = navigator.connection && navigator.connection.saveData;
  const observer = !saveData && 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      entry.target.querySelectorAll('[aria-controls^="quick-buy-horizontal-"]').forEach((button) => prefetch(drawerFor(button)));
    });
  }, { rootMargin: '200px 0px' }) : null;

  // The product info is re-rendered on variant change, which brings a new list.
  function observeLists() {
    if (!observer) return;
    document.querySelectorAll('.product-info__complementary-products').forEach((list) => {
      if (list._blQuickBuyObserved) return;
      list._blQuickBuyObserved = true;
      observer.observe(list);
    });
  }

  function onIntent(event) {
    const button = event.target.closest && event.target.closest(FBT_BUTTON);
    if (button) prefetch(drawerFor(button));
  }
  document.addEventListener('pointerover', onIntent);
  document.addEventListener('focusin', onIntent);
  document.addEventListener('variant:change', () => setTimeout(observeLists));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLists);
  } else {
    observeLists();
  }
})();

/********************************
 * Quick buy cards – Product Cards (Wipes) in the quick buy drawer
 ********************************/
// snippets/product-cards-wipes.liquid with drawer: true (snippets/product-quick-buy-wipes.liquid) renders the page's
// cards inside <bl-quick-cards>, without the page's script. The chosen card's variant goes into the drawer's product
// form, so a card of another product (the Mix Box, SilkyFlush 4 × 56s) adds that product, and the card's
// <template data-bl-pcard-header> (image, product title, price) replaces the drawer header. The page's card, else the
// first available card, starts selected.
class BlQuickCards extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this);
    const checked = this.querySelector('.bl-pcard__input:checked:not(:disabled)');
    this.select(
      (checked && checked.closest('[data-bl-pcard]')) ||
      this.querySelector('[data-bl-pcard-match]:not(.is-disabled)') ||
      this.querySelector('[data-bl-pcard]:not(.is-disabled)')
    );
  }

  disconnectedCallback() {
    this.removeEventListener('change', this);
  }

  handleEvent(event) {
    if (event.target.matches('.bl-pcard__input')) this.select(event.target.closest('[data-bl-pcard]'));
  }

  select(card) {
    if (!card) return;
    const input = card.querySelector('.bl-pcard__input');
    if (input) input.checked = true;
    this.querySelectorAll('[data-bl-pcard]').forEach((other) => other.classList.toggle('is-selected', other === card));

    // `form.id` would be the hidden variant input (see "Add-to-cart label by purchase option"): read it by name.
    const form = document.forms[this.dataset.formId];
    const variantField = form && form.elements.namedItem('id');
    if (variantField) variantField.value = card.dataset.variantId;

    const header = this.closest('product-rerender')?.querySelector('[slot="header"]');
    const template = card.querySelector('template[data-bl-pcard-header]');
    if (header && template) header.replaceChildren(template.content.cloneNode(true));
  }
}

if (!customElements.get('bl-quick-cards')) {
  customElements.define('bl-quick-cards', BlQuickCards);
}

/********************************
 * Product reviews – topic tabs (v3.0_19 §12–13)
 ********************************/
// The Junip "Product Reviews" block in the apps section that the Pure Diaper, Pure Pants and wipes templates share
// (section key 177926828832247303; styles in bl-custom.css, "Product reviews: sort, rating filter and topic tabs").
// Junip renders the reviews and its own summary, sort and rating filter; this adds the prototype's topic tabs. A topic
// matches a review when its title or text contains one of the topic's words. Junip keeps every review in the page and
// shows five at a time, so picking a topic first opens the full list ("See more reviews", no extra requests), then
// hides the reviews without a match. Junip re-renders the list on sort / rating changes; the filter is re-applied.
(function () {
  const ROOT = '[id$="__177926828832247303"]';
  const TOPICS = {
    diaper: [
      ['overnight', 'Overnight', /(night|slept|sleep|bedtime)/i],
      ['leaks', 'Leak protection', /\b(leak\w*|blowouts?|dry)\b/i],
      ['skin', 'Skin comfort', /\b(skin|rash\w*|sensitive|redness|red marks?|irritat\w*|eczema)\b/i],
      ['absorbency', 'Absorbency', /\b(absorb\w*|wet\w*|pee|urine|soak\w*|holds?)\b/i],
      ['softness', 'Soft & comfy', /\b(soft\w*|comfy|comfort\w*|gentle|thin|slim|smooth|breathab\w*)\b/i]
    ],
    wipes: [
      ['softness', 'Softness', /\b(soft\w*|gentle|smooth|silky|thick\w*|texture)\b/i],
      ['skin', 'Skin comfort', /\b(skin|rash\w*|sensitive|redness|irritat\w*|eczema|gentle|comfortabl\w*|soothing)\b/i],
      ['everyday', 'Everyday use', /\b(every ?day|daily|diaper changes?|nappy|bottoms?|routine)\b/i],
      ['go', 'On the go', /\b(on the go|travel\w*|bags?|outings?|out and about|portable|pocket|car|outside)\b/i],
      ['cleanups', 'Clean-ups', /\b(clean\w*|mess\w*|spills?|hands|face|toys?|sticky|surfaces?)\b/i]
    ]
  };

  function topicsFor() {
    return /\/products\/[^/?#]*(diaper|pant)/i.test(window.location.pathname) ? TOPICS.diaper : TOPICS.wipes;
  }

  function addChips(container, state) {
    const filters = container.querySelector('.junip-filters');
    if (!filters) return;
    // On phones Junip shows a "Filter" button and renders the rating and sort only once it is tapped; open them, as
    // the prototype shows them inline (the button itself is hidden in bl-custom.css). A click before Junip has wired
    // the button does nothing, so check again shortly (up to 6 tries).
    const toggle = filters.querySelector('.junip-filters-toggle');
    if (toggle && !filters.querySelector('.junip-filters-container') && state.opens < 6) {
      state.opens++;
      toggle.click();
      setTimeout(() => addChips(container, state), 500);
    }
    if (filters.querySelector('.bl-rv-topics')) return;
    const group = document.createElement('div');
    group.className = 'bl-rv-topics';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', 'Filter reviews by topic');
    [['all', 'All', null], ...state.topics].forEach(([key, label]) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'bl-rv-topic';
      chip.dataset.topic = key;
      chip.textContent = label;
      chip.setAttribute('aria-pressed', String(key === state.topic));
      group.append(chip);
    });
    group.addEventListener('click', (event) => {
      const chip = event.target.closest('.bl-rv-topic');
      if (chip) select(container, state, chip.dataset.topic);
    });
    filters.prepend(group);
  }

  // Each "See more" shows the next reviews, from memory or (past the first batch) from Junip's server: wait up to
  // 3 s for the list to grow before the next click, and stop when it does not.
  async function openAll(container) {
    const count = () => container.querySelectorAll('.junip-review-list-item-container').length;
    for (let page = 0; page < 40; page++) {
      const more = container.querySelector('.junip-see-more');
      if (!more) return;
      const before = count();
      more.click();
      for (let wait = 0; wait < 60 && count() <= before; wait++) {
        await new Promise((resolve) => setTimeout(resolve, 50));
      }
      if (count() <= before) return;
    }
  }

  async function select(container, state, topic) {
    state.topic = topic;
    container.querySelectorAll('.bl-rv-topic').forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.topic === topic)));
    if (topic !== 'all') {
      apply(container, state);
      container.setAttribute('aria-busy', 'true');
      await openAll(container);
      container.removeAttribute('aria-busy');
    }
    apply(container, state);
  }

  function apply(container, state) {
    const list = container.querySelector('.junip-reviews-container');
    if (!list) return;
    const entry = state.topics.find(([key]) => key === state.topic);
    let shown = 0;
    list.querySelectorAll('.junip-review-list-item-container').forEach((item) => {
      const text = Array.from(item.querySelectorAll('.junip-review-title, .junip-review-body')).map((el) => el.textContent).join(' ');
      const match = !entry || entry[2].test(text);
      item.classList.toggle('bl-rv-hidden', !match);
      if (match) shown++;
    });

    let empty = container.querySelector('.bl-rv-empty');
    // While the list is still opening (aria-busy), a topic with no match yet may still find one further down.
    if (entry && shown === 0 && !container.hasAttribute('aria-busy')) {
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'bl-rv-empty';
        empty.innerHTML = 'No reviews mention this yet.<button type="button">Show all reviews</button>';
        empty.querySelector('button').addEventListener('click', () => select(container, state, 'all'));
        list.after(empty);
      }
    } else if (empty) {
      empty.remove();
    }
  }

  function setup(container) {
    if (container._blRv) return;
    container._blRv = true;
    const state = { topic: 'all', topics: topicsFor(), opens: 0 };
    addChips(container, state);
    // Junip re-renders parts of the widget (sort, rating, See more): put the tabs back and re-filter.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      setTimeout(() => {
        queued = false;
        addChips(container, state);
        if (state.topic !== 'all') apply(container, state);
      }, 30);
    }).observe(container, { childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll(`${ROOT} .junip-product-review-container`).forEach(setup);
  }

  if (!document.querySelector(ROOT)) return;
  // Junip renders after its script loads; look until the widget is there (up to about 30 s).
  let tries = 0;
  const timer = setInterval(() => {
    scan();
    if (document.querySelector(`${ROOT} .junip-product-review-container`) || ++tries > 60) clearInterval(timer);
  }, 500);
})();

/********************************
 * Hoppi Points line (v3.0_19) – snippets/bl-points-earn.liquid
 ********************************/
// Under the buy button: "Earn 10 Hoppi Points for every $1" until the button shows a price, then the points for that
// price ("ADD TO CART — $96" → "Earn 960 Hoppi Points"), rounded as in the prototype. The form's area is watched
// rather than the button itself, since the theme may replace the button when the variant changes.
if (!customElements.get('bl-points-earn')) {
  customElements.define('bl-points-earn', class BlPointsEarn extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-earn-text]');
      this.perDollar = Number(this.dataset.perDollar) || 10;
      if (!this.text || !this.parentElement) return;
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.parentElement, { childList: true, characterData: true, subtree: true });
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    update() {
      const button = this.parentElement?.querySelector('buy-buttons button[type="submit"]');
      const match = button?.textContent.match(/\$\s?([\d,]+(?:\.\d+)?)/);
      const html = match
        ? `Earn <strong>${Math.round(parseFloat(match[1].replace(/,/g, '')) * this.perDollar).toLocaleString('en-SG')}</strong> Hoppi Points`
        : `Earn <strong>${this.perDollar}</strong> Hoppi Points for every $1`;
      if (this.text.innerHTML !== html) this.text.innerHTML = html;
    }
  });
}
